import { render, staticRenderFns } from "./SlideBrands.vue?vue&type=template&id=0c4fd29a&scoped=true"
import script from "./SlideBrands.vue?vue&type=script&lang=js"
export * from "./SlideBrands.vue?vue&type=script&lang=js"
import style0 from "./SlideBrands.vue?vue&type=style&index=0&id=0c4fd29a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4fd29a",
  null
  
)

export default component.exports